// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__90J5J","itemTitle":"ClientEmergencyInfo_itemTitle__1sqAQ","itemText":"ClientEmergencyInfo_itemText__1PMyP"};